import { AutogenModelServiceIncidentStop, AutogenRowServiceIncidentStop } from "./autogen/AutogenModelServiceIncidentStop";

export class ModelServiceIncidentStop extends AutogenModelServiceIncidentStop<RowServiceIncidentStop> {
	constructor() {
		super(RowServiceIncidentStop);
	}
}

export class RowServiceIncidentStop extends AutogenRowServiceIncidentStop {
}